export function initContactFormInstance(options) {
    // options: {
    //   container: HTMLElement or selector string,
    //   formItem: object,
    //   siteKey: string,
    //   saveUrl: string,
    //   widgetGuid: string
    // }

    var $container = typeof options.container === "string" ? $(options.container) : $(options.container);
    var formItem = options.formItem;
    var siteKey = options.siteKey;
    var saveUrl = options.saveUrl;
    var widgetGuid = options.widgetGuid;

    // Hide result message on load
    $container.find("#pResultMessage").hide();

    // Loader functions
    function showLoader() {
        $container.find("#modalLoader-" + widgetGuid).show();
    }
    function hideLoader() {
        $container.find("#modalLoader-" + widgetGuid).hide();
    }

    // Save form function
    function saveForm() {
        showLoader();

        var date = new Date();
        formItem.formInserted = date.toISOString();
        formItem.formUpdated = date.toISOString();
        formItem.firstName = $container.find("#tbFirstName").val();
        formItem.lastName = $container.find("#tbLastName").val();
        formItem.company = $container.find("#tbCompany").val();
        formItem.email = $container.find("#tbEmail").val();
        formItem.phone = $container.find("#tbPhone").val();
        formItem.country = $container.find("#ddlCountry option:selected").text();
        formItem.tailNumber = $container.find("#tbTailNumber").val();
        formItem.product = $container.find("#ddlProduct option:selected").text();
        formItem.comments = $container.find("#tbComments").val();

        $.ajax({
            url: saveUrl,
            type: "POST",
            data: formItem,
            success: function (response) {
                if (response == 'success') {
                    $container.find("#pForm").hide();
                    $container.find("#pResultMessage").show();
                }
                hideLoader();
            },
            error: function () {
                hideLoader();
            }
        });
    }

    // Validation logic
    var forms = $container.find(".needs-validation");
    var validateGroup = $container.find(".validate-me");

    forms.each(function () {
        var form = this;
        form.addEventListener('submit', function (event) {
            event.preventDefault();

            if (form.checkValidity() === false) {
                event.stopPropagation();
            } else {
                grecaptcha.ready(function () {
                    grecaptcha.execute(siteKey, { action: 'submit' }).then(function (token) {
                        formItem.reCaptcha = token;
                        saveForm();
                    });
                });
            }

            validateGroup.each(function () {
                $(this).addClass('was-validated');
            });
        }, false);
    });

    var email = $container.find("#tbEmail")[0];
    if (email) {
        email.oninput = function () {
            if (!isEmailValid(email.value)) {
                email.setCustomValidity("Invalid field.");
            } else {
                email.setCustomValidity("");
            }
        }
    }
}

window.initContactFormInstance = initContactFormInstance;